import script from "./MyTicketInput.vue?vue&type=script&setup=true&lang=js"
export * from "./MyTicketInput.vue?vue&type=script&setup=true&lang=js"

import "./MyTicketInput.vue?vue&type=style&index=0&id=c926fc9c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c926fc9c"]])

export default __exports__